import { Auth } from 'aws-amplify';

const user = async (action) => {
  try {
    var userInfo = await Auth.signIn(action.email, action.password);
    return userInfo;
  } catch (e) {
    console.log('awsUserLogin:user - Error signing in: ', e);
    return e;
  }
};

const currentJwtToken = async (action) => {
  try {
    var userInfo = await Auth.signIn(action.email, action.password);
    return userInfo.signInUserSession.idToken.jwtToken;
  } catch (e) {
    console.log('awsUserLogin:currentJwtToken - Error signing in: ', e);
    return e;
  }
};

export default { user, currentJwtToken };
